var sound_control_rtlignore_default = {
  "root": "SWelP",
  "sliderContainer": "sTExA"
};
export {
  sound_control_rtlignore_default as default
};
//# sourceMappingURL=sound-control.rtlignore-scss.js.map
